import { render, staticRenderFns } from "./BriqPagination.vue?vue&type=template&id=783b9cde&scoped=true&lang=pug&"
import script from "./BriqPagination.vue?vue&type=script&lang=js&"
export * from "./BriqPagination.vue?vue&type=script&lang=js&"
import style0 from "./BriqPagination.vue?vue&type=style&index=0&id=783b9cde&lang=stylus&scoped=true&"
import style1 from "./BriqPagination.vue?vue&type=style&index=1&id=783b9cde&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783b9cde",
  null
  
)

export default component.exports